import React from 'react';
import { useParams } from 'react-router-dom';
import VariantOptionForm from '../../Components/VariantOptions/VariantOptionForm';

/**
 * Component for editing an existing variant option
 * @returns {JSX.Element} VariantOptionEdit component
 */
const VariantOptionEdit = () => {
  const { slack, lng } = useParams();
  
  return <VariantOptionForm slack={slack} lng={lng} />;
};

export default VariantOptionEdit;
